import {
  AugmentationToolbarButton,
  AugmentationToolbarOption
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { useEffect } from "react"
import ChangelogIframe from "../../changelog/ChangelogIframe"
import useChangelogUnreadIndicator from "../../changelog/useChangelogUnreadIndicator"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { canAdministrate } from "../../user/permissions"

const ChangelogAugmentation: AugmentationToolbarOption["AugmentationComponent"] =
  ({ toolbar }) => {
    const [hasUnread, handleRead] = useChangelogUnreadIndicator() as [
      boolean,
      () => void
    ]

    useEffect(() => {
      handleRead()
    }, [])

    return <ChangelogIframe onClose={() => toolbar.onSelect(null)} />
  }

const ChangelogToolbarComponent: AugmentationToolbarOption["ToolbarComponent"] =
  (props) => {
    const [hasUnread, handleRead] = useChangelogUnreadIndicator() as [
      boolean,
      () => void
    ]

    return (
      <AugmentationToolbarButton
        {...props}
        option={{ ...props.option, indicator: hasUnread }}
      />
    )
  }

function useChangelogAugmentationToolbarOption(): AugmentationToolbarOption | null {
  const pwContext = usePathwrightContext()

  if (canAdministrate(pwContext)) {
    return {
      key: "changelog",
      icon: "bolt-fill",
      label: "Changelog",
      ToolbarComponent: ChangelogToolbarComponent,
      AugmentationComponent: ChangelogAugmentation
    }
  }

  return null
}

export default useChangelogAugmentationToolbarOption
